import React from 'react';

const GenerateBilling = () => (
	<div>GENERATE BILLING</div>
);

export default GenerateBilling;
